import { resolveComponent as _resolveComponent, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8eaf82ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sc_icon = _resolveComponent("sc-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_sc_btn = _resolveComponent("sc-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["line", { active: _ctx.node.selected }]),
    style: _normalizeStyle({ paddingLeft: _ctx.node.level * 22 + 'px' }),
    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.node.select(!_ctx.node.selected)))
  }, [
    _createElementVNode("span", {
      class: "arrow",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.node.setOpen(!_ctx.node.opened)))
    }, [
      _withDirectives(_createVNode(_component_sc_icon, {
        type: _ctx.node.opened ? 'CaretRightOutlined' : 'CaretDownOutlined'
      }, null, 8, ["type"]), [
        [_vShow, _ctx.node.children.length > 0]
      ])
    ]),
    _createElementVNode("span", _hoisted_1, [
      _createVNode(_component_a_checkbox, {
        checked: _ctx.node.checked === 'yes',
        indeterminate: _ctx.node.checked === 'half',
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.node.check(_ctx.node.checked !== 'yes')))
      }, null, 8, ["checked", "indeterminate"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, [
        _createVNode(_component_sc_icon, {
          type: _ctx.node.data.class
        }, null, 8, ["type"])
      ]),
      _createVNode(_component_a_input, {
        class: "class",
        size: "small",
        value: _ctx.node.data.class,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('data', { class: $event })))
      }, null, 8, ["value"]),
      _createVNode(_component_a_input, {
        class: "title",
        size: "small",
        value: _ctx.node.data.title,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('data', { title: $event })))
      }, null, 8, ["value"]),
      (_ctx.node.level > 0 && _ctx.node.children.length === 0)
        ? (_openBlock(), _createBlock(_component_a_input, {
            key: 0,
            class: "path",
            size: "small",
            style: {"margin-right":"10px"},
            value: _ctx.node.data.path,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('data', { path: $event })))
          }, null, 8, ["value"]))
        : _createCommentVNode("", true),
      (_ctx.node.level !== 2)
        ? (_openBlock(), _createBlock(_component_sc_btn, {
            key: 1,
            text: "add",
            size: "small",
            style: {"margin-right":"10px"},
            handler: () => _ctx.$emit('add')
          }, null, 8, ["handler"]))
        : _createCommentVNode("", true),
      _createVNode(_component_sc_btn, {
        text: "del",
        size: "small",
        type: "danger",
        confirm: "确定",
        handler: () => _ctx.node.del(),
        style: {"margin-right":"10px"}
      }, null, 8, ["handler"])
    ])
  ], 6))
}